import { Flex } from 'antd'
import React from 'react'

import SectionTitle from '../section-title'

import ChatterPerformanceLineChart, { ChartData, StrokeColors } from './chatter-performance-line-chart'

export interface ChatterPerformanceActivityProps {
  data: ChartData
}

export default function ChatterPerformanceActivity({ data }: ChatterPerformanceActivityProps) {
  return (
    <Flex vertical gap={8}>
      <SectionTitle
        title="Chatter activity"
        tooltip="Chatter activity based on the number of words the Chatter has sent to fans"
      />
      <ChatterPerformanceLineChart data={data} stroke={StrokeColors.ChatterActivity} />
    </Flex>
  )

}